import { DateRange } from '@softline/ui-core';

export interface DateRangePickerShortcut {
  readonly value: DateRange;
  readonly label: string;
}

export const DATE_RANGE_PICKER_SELECTION_MODES = ['range', 'preset-range'] as const;
export type DateRangePickerSelectionMode =
  (typeof DATE_RANGE_PICKER_SELECTION_MODES)[number];

export const DATE_RANGE_PICKER_DEFAULT_SHORTCUTS = [
  {
    label: 'Gestern',
    value: { from: 'h-1', to: 'h-1' },
  },
  {
    label: 'Diese Woche',
    value: { from: 'mo', to: 'h' },
  },
  {
    label: 'Dieses Monat',
    value: { from: 'ma', to: 'h' },
  },
  {
    label: 'Letzte Woche',
    value: { from: 'mo-1', to: 'so-1' },
  },
  {
    label: 'Letztes Monat',
    value: { from: 'ma-1', to: 'me-1' },
  },
  {
    label: 'Letzten 7 Tage',
    value: { from: 'h-7', to: 'h' },
  },
  {
    label: 'Letzten 30 Tage',
    value: { from: 'h-30', to: 'h' },
  },
] as const satisfies readonly DateRangePickerShortcut[];

export const DATE_RANGE_PICKER_LONG_SHORTCUTS = [
  {
    label: 'Diese Woche',
    value: { from: 'mo', to: 'h-1' },
  },
  {
    label: 'Dieses Monat',
    value: { from: 'ma', to: 'h' },
  },
  {
    label: 'Dieses Jahr',
    value: { from: 'ja', to: 'h' },
  },
  {
    label: 'Letzte Woche',
    value: { from: 'mo-1', to: 'so-1' },
  },
  {
    label: 'Letztes Monat',
    value: { from: 'ma-1', to: 'me-1' },
  },
  {
    label: 'Letztes Jahr',
    value: { from: 'ja-1', to: 'je-1' },
  },
  {
    label: 'Letzten 7 Tage',
    value: { from: 'h-7', to: 'h' },
  },
  {
    label: 'Letzten 30 Tage',
    value: { from: 'h-30', to: 'h' },
  },
] as const satisfies readonly DateRangePickerShortcut[];

export const defaultDateRangeShortcuts = DATE_RANGE_PICKER_DEFAULT_SHORTCUTS;
export const longDateRangeShortcuts = DATE_RANGE_PICKER_LONG_SHORTCUTS;
